module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/unit-or-sublot-allocation-methods/unit-or-sublot-allocation-methods.component.css
// module id = ./src/app/unit-or-sublot-allocation-methods/unit-or-sublot-allocation-methods.component.css
// module chunks = main